// noinspection JSVoidFunctionReturnValueUsed

import React, {useEffect} from "react";
import Container from 'react-bootstrap/Container';
import '../Lg.css';
import {TildaB} from "./common/TildaB";
import {logPageOpened} from "../../model/utils";
import {
    calcMotivationForNextLm,
    calcNameOfConcert,
    calcNectLmUrl,
    calcNextLmButtonName, calculateShortPageUrlNew,
    calcWhere,
    registerClick
} from "./common/LgHelper";
import {appdata, save} from "../../../logic_tmp/appdata/AppData";
import {useTranslation} from "react-i18next";
import {registerConcersion} from "../../../logic/funel/FacebookUtils";
import i18next from "i18next";
import {useHistory} from "react-router-dom";
import {logBack} from "../../../backend/connectors/JavaConnector";
import {calcUtmString} from "../../../logic/setup/UtmParser";


export function CelloLgFooter() {
    const {t} = useTranslation()
    const history = useHistory();
    appdata.viewType = "LeadMagnetPage"
    useEffect(() => {
        logPageOpened(appdata.parentPath,appdata.viewType)
    }, []);



    function toThankYouMessage() {
        logToBack("NONE")
        appdata.messageKey = "ThankYou"

        save()
        history.push("/genericMessage");
    }

    function logToBack(action) {
        appdata.utm_source = "CelloLeadGenNotify"
        appdata.utm_medium = action
        logBack(calcUtmString(appdata))
    }

    return (<div>
        <Container>
            <TildaB>
                <a id = "toNextLm" onClick={()=>logToBack("SPAIN")}  href={"/begin?productCode=CELLOLEADS-2024.01.01_SPAIN-LEAD-GEN&lng=" + i18next.language + "&utm_medium=" + appdata.utm_medium} target="_parent"
                   className="myButton myButtonYellow">{t("AndalusianRomance")}</a>
            </TildaB>
            <TildaB>
                <a id = "toConcertShort" onClick={()=>logToBack("EU")} href={"/begin?productCode=CELLOLEADS-2024.01.01_EU-LEAD-GEN&lng=" + i18next.language + "&utm_medium=" + appdata.utm_medium} target="_parent"
                   className="myButton myButtonYellow">{t("IncredibleJourneywithaCelloAcrossEurope")}</a>
            </TildaB>
            <TildaB>
                <a id = "toConcertShort" onClick={()=>logToBack("BOTH")} href={"/begin?productCode=CELLOLEADS-2024.01.01_BOTH-LEAD-GEN&lng=" + i18next.language + "&utm_medium=" + appdata.utm_medium} target="_parent"
                   className="myButton myButtonYellow">{t("BothConcerts")}</a>
            </TildaB>
            <TildaB>
                <a id = "toConcertShort" onClick={()=>toThankYouMessage()} href={""} target="_parent"
                   className="myButton myButtonLrrh">{t("NoneOfConcerts")}</a>
            </TildaB>

        </Container>
    </div>);
}

